import React, { useState } from 'react';
import Swal from 'sweetalert2';

import {
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Alert,
  Spinner,
} from 'reactstrap';

import { Editor, EditorProvider } from 'react-simple-wysiwyg';

import 'react-datepicker/dist/react-datepicker.css';
import 'flatpickr/dist/themes/material_blue.css';
import 'flatpickr/dist/plugins/monthSelect/style.css';
import axios from 'axios';
import { api } from '../../config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logger from '../../utils/logger';
import { formatDateToDDMMYYYY } from '../../utils/dateformatter';

import { downloadParcelFreightExcel } from './utils/FreightCostHelpers';
import CargoDeliveryTable, {
  buildCargoDeliveryExportRows,
  useDeliveryParcels,
  CARGO_DELIVERY_COLUMNS,
} from './component/CargoDeliveryTable';
import UploadParcelModal from './component/UploadParcelModal';
import '../../App.css';
import './FreightCostView.css';
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const RequirementTab = ({
  ids,
  form,
  _setForm,
  _dataCause,
  _handleSaveDraftProc,
  _validatedeliveryModal,
  _errors,
  _error,
  _setError,
  _setErrors,
  _setIsLoading,
  _isLoading,
  _qtyDeliveryData,
  token,
}) => {
  const {
    response: parcelResponse,
    isLoading: isLoadingParcels,
    error: parcelsError,
    refresh: refreshParcels,
  } = useDeliveryParcels(ids, token);
  const [isExportingExcel, setIsExportingExcel] = useState(false);
  const [isUploadParcelOpen, setIsUploadParcelOpen] = useState(false);

  const toggleUploadParcel = () => setIsUploadParcelOpen(open => !open);

  const exportParcelFreightToExcel = response => {
    const rows = buildCargoDeliveryExportRows(response);
    if (!rows.length) {
      toast.error('No FOB incoterm data available to export.');
      return false;
    }

    setIsExportingExcel(true);
    try {
      downloadParcelFreightExcel(
        rows,
        'Parcel_Request_Freight_Availability.xlsx',
        CARGO_DELIVERY_COLUMNS
      );
      return true;
    } catch (error) {
      toast.error(error?.message || 'Failed to export parcel data to Excel.');
      return false;
    } finally {
      setIsExportingExcel(false);
    }
  };

  const procurementTypeMap = {
    PelelanganKhusus: 'Pelelangan Khusus',
    PemilihanLangsung: 'Pemilihan Langsung',
    TunjukLangsung: 'Tunjuk Langsung',
  };

  const handleConfirmProcess = () => {
    Swal.fire({
      title: 'Are You Sure?',
      text: 'Data will be processed',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Process',
      cancelButtonText: 'Cancel',
    }).then(result => {
      if (result.isConfirmed) {
        handleSaveReleasedHps(ids);
      } else {
        logger.log('User membatalkan');
      }
    });
  };

  const handleSaveReleasedHps = async releaseIds => {
    try {
      const response = await axios.put(
        `${api.API_URL}/procurement/freight-cost-submit/${releaseIds}`,
        null,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      logger.log('Response:', response.data);
    } catch (error) {
      logger.error('Error submit procurement:', error.message);
    }
  };

  return (
    <React.Fragment>
      <Row>
        <div>
          <Card className='border shadow-sm'>
            <CardBody>
              <Row>
                <Col sm={12}>
                  <div
                    color='dark'
                    className='d-flex align-items-center mb-2  '
                  >
                    <div className='flex-grow-1'>
                      <h5 className='mb-1'>
                        <i className='ri-file-list-3-line me-2'></i>
                        Request Freight Availability
                      </h5>
                      <p className='text-muted mb-2 fs-12 '>
                        Bisa jadi Kalimat tambahan untuk membantu section
                        mengenai apa ini
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractType' className='text-muted'>
                      Freight Requst Number :
                    </Label>
                    <p className='form-label mb-2 fs-12 '>
                      {form?.freightRequestNumber}
                    </p>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractType' className='text-muted'>
                      Freight Request Date :
                    </Label>
                    <p className='form-label mb-2 fs-12 '>
                      {form?.freightRequestDate
                        ? formatDateToDDMMYYYY(form.freightRequestDate)
                        : null}
                    </p>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Card className='border shadow-sm'>
            <CardBody>
              <Row>
                <Col sm={12}>
                  <div
                    color='dark'
                    className='d-flex align-items-center mb-2  '
                  >
                    <div className='flex-grow-1'>
                      <h5 className='mb-1'>
                        <i className='ri-file-list-3-line me-2'></i>
                        Procurement Information
                      </h5>
                      <p className='text-muted mb-2 fs-12 '>
                        Bisa jadi Kalimat tambahan untuk membantu section
                        mengenai apa ini
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractType' className='text-muted'>
                      Procurement Type :
                    </Label>
                    <p className='form-label mb-2 fs-12 '>
                      {form?.procurementTypeHeaderLabel}
                    </p>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractType' className='text-muted'>
                      Title Procurement :
                    </Label>
                    <p className='form-label mb-2 fs-12 '>
                      {form?.titleProcurement}
                    </p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractType' className='text-muted'>
                      Proc Type:
                    </Label>
                    <p className='form-label mb-2 fs-12 '>
                      {procurementTypeMap[form.procurementType] || '-'}
                    </p>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={12}>
                  <Card>
                    <p
                      id='req-sec-product'
                      className=' mt-2 form-label mb-1 fs-13  '
                    >
                      Description
                    </p>

                    <EditorProvider>
                      <Editor
                        id='productSpecification'
                        name='productSpecification'
                        value={form.productSpecification || ''}

                        style={{ height: '200px', overflowY: 'auto' }}
                        className={
                          form.description === false
                            ? 'form-control'
                            : 'form-control bg-light border-0'
                        }
                      ></Editor>
                    </EditorProvider>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Card className='border shadow-sm'>
            <CardBody>
              <Row>
                {form.statusHPS2 === false && (
                  <Col lg={12}>
                    <Alert
                      color='info'
                      className='d-flex align-items-start gap-2 mt-2'
                    >
                      <i className='bx  bx-error flex-shrink-0 mt-1'></i>
                      <span className='small'>
                        The detailed procurement plan information below can be
                        downloaded in Excel format to be used as an attachment
                        in the submission of the Freight Cost and Availability
                        Request Memorandum..
                      </span>
                    </Alert>
                  </Col>
                )}
              </Row>

              <Row>
                <div className='d-flex align-items-center justify-content-between mb-3'>
                  <div>
                    <h5 className='fw-semibold mb-1'>Parcel</h5>
                    <p className='text-muted small mb-0'>
                      Delivery terms mapped from procurement planning.
                    </p>
                  </div>
                  <div className='d-flex align-items-center gap-2'>
                    <Button
                      color='success'
                      size='sm'
                      className='d-flex align-items-center gap-1'
                      disabled={isExportingExcel || isLoadingParcels}
                      onClick={() => exportParcelFreightToExcel(parcelResponse)}
                    >
                      {isExportingExcel ? (
                        <Spinner size='sm' />
                      ) : (
                        <i className='bx bxs-file-export'></i>
                      )}{' '}
                      Download Parcel
                    </Button>
                    {form.freightCostStatus === false && (
                      <Button
                        color='primary'
                        size='sm'
                        className='d-flex align-items-center gap-1'
                        onClick={toggleUploadParcel}
                      >
                        <i className='bx bxs-file-import'></i> Upload Parcel
                      </Button>
                    )}
                  </div>
                </div>

                <CargoDeliveryTable
                  response={parcelResponse}
                  loading={isLoadingParcels}
                  error={parcelsError}
                />

                <UploadParcelModal
                  isOpen={isUploadParcelOpen}
                  toggle={toggleUploadParcel}
                  procurementId={ids}
                  token={token}
                  onUploaded={refreshParcels}
                />
              </Row>
            </CardBody>
          </Card>
        </div>

        <div className='d-flex align-items-start gap-3 mb-4'>
          {form.freightCostStatus === false && (
            <button
              type='button'
              className='btn btn-primary btn-label right ms-auto nexttab'
              onClick={handleConfirmProcess}
            >
              <i className='ri-login-box-line  label-icon align-middle fs-16 ms-2'></i>
              Save & Released
            </button>
          )}
        </div>
      </Row>
    </React.Fragment>
  );
};

export default RequirementTab;
